import React from "react";
import { SubSection } from "context/BlogContext";

interface PreviewParagraphProps {
  subSection: SubSection;
}

const PreviewParagraph: React.FC<PreviewParagraphProps> = ({ subSection }) => {  
  return (
    <div>
      {subSection.type === "paragraph" && (
        <p className="pt-4" dangerouslySetInnerHTML={{ __html: subSection.attrs.text }}></p>
      )}
    </div>
  );
};

export default PreviewParagraph;
